const getSelectOptionText = (node) => {
	if (node === null || node === undefined) {
		return "";
	}

	if (typeof node === "string" || typeof node === "number") {
		return String(node);
	}

	if (Array.isArray(node)) {
		return node.map(getSelectOptionText).join(" ");
	}

	if (node.props && node.props.children) {
		return getSelectOptionText(node.props.children);
	}

	return "";
};

export const filterSelectOption = (input, option) =>
	getSelectOptionText(option.props.children)
		.toLowerCase()
		.includes(input.toLowerCase());
